// import { combineReducers } from 'redux'
import { routerReducer as routing} from 'react-router-redux'
import app from './app'
import data from './data'

// import { localeReducer } from 'react-localize-redux';

export default (state = {}, action) => {
	return {
		app: app(state.app, action, state),
		routing: routing(state.routing, action, state),
		data: data(state.data, action, state),
	};
};


// WEBPACK FOOTER //
// ./src/behaviors/index.js